import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";

const CardAi = ({
  nome,
  descricao,
  icon = "pi-robot",
  route,
  header,
  id,
  detalhes,
  hasPermission = true,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  return (
    <>
      {loading ? (
        <div className="bg-card-ai position-relative rounded-4 overflow-hidden d-flex flex-column align-items-center justify-content-center p-3">
          <Skeleton width="100%" height="200px" className="mb-3" />
          <Skeleton width="80%" height="20px" className="mb-2" />
          <Skeleton width="60%" height="20px" />
        </div>
      ) : (
        <div
          className="bg-card-ai rounded-4 overflow-hidden shadow-sm transition-transform"
          style={{ position: "relative", transition: "0.3s ease" }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.02)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1.0)")}
        >
          <div
            className="bg-header-card position-relative w-100"
            style={{ height: "150px" }}
          >
            {header ? (
              <img
                src={header}
                alt="header"
                className="w-100 h-100 position-absolute top-0 start-0"
                style={{ objectFit: "cover", opacity: 0.85 }}
              />
            ) : (
              <span
                className={`pi ${icon}`}
                style={{
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                  fontSize: "110px",
                  opacity: 0.1,
                  zIndex: 1,
                }}
              />
            )}

            {/* Ícone e tag */}
            <div
              style={{
                position: "absolute",
                left: "16px",
                bottom: "-35px",
                zIndex: 3,
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  background: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "4px solid #14b8a6",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
                  overflow: "visible", 
                }}
              >
                {icon && (icon.startsWith('http') || icon.startsWith('/')) ? (
                  <img
                    src={icon}
                    alt="icon"
                    style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }}
                  />
                ) : (
                  <span
                    className={`pi ${icon}`}
                    style={{ color: "#14b8a6", fontSize: "2rem" }}
                  />
                )}

                <div
                  style={{
                    position: "absolute",
                    bottom: "-10px",
                    right: "-10px",
                  }}
                >
                  <Tag
                    value="Novo"
                    severity="success"
                    style={{
                      fontSize: "0.65rem",
                      padding: "3px 6px",
                      borderRadius: "10px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="pt-5 px-4 pb-3">
            <h2 className="mt-4 mb-2 fw-bold text-center">{nome}</h2>
            <p className="mb-3 fs-6 text-center" style={{ opacity: 0.85 }}>
              {descricao}
            </p>
            <div className="d-flex justify-content-center gap-2">
              <Button
                icon="fa-solid fa-circle-info fa-lg"
                tooltip="Detalhes"
                tooltipOptions={{ position: "top" }}
                className="p-button-sm p-button-rounded p-button-primary my-2 me-2"
                onClick={(e) => {
                  e.stopPropagation();
                  setLoading(true);
                  if (id) {
                    navigate(`./detailsAI/${id}`, {
                      state: { nome, descricao, detalhes, header, icon, hasPermission },
                    });
                  } else if (route) {
                    navigate(route);
                  }
                }}
              />
              {hasPermission && (
                <Button
                  icon="fa-solid fa-gears fa-lg"
                  className="p-button-sm p-button-rounded p-button-secondary my-2 me-2"
                  tooltip="Configurar"
                  tooltipOptions={{ position: "top" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (route) navigate(route);
                  }}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CardAi;
